<template>
  <div class="page">
    <router-link to="/events-promotions" class="page-explorer__block page-block--main" style="background-color: #2D88BC">
      <div class="page-explorer-block__icon"><img src="@/assets/icons/balloon.svg" alt=""></div>
      <div class="page-block__heading">What's Happening in Otahuhu</div>
    </router-link>
    <a href="/explore-local/community" class="page-explorer__block page-block--main" style="background-color: #83c815">
      <div class="page-explorer-block__icon"><img src="@/assets/icons/balloon.svg" alt=""></div>
      <div class="page-block__heading">Connecting Our Community</div>
    </a>
    <smart-block
        link="/whats-on/auckland-live"
        icon="https://ucarecdn.com/25f9bbba-fd59-424d-8e40-bb77b4fa7cf1/aucklandevents.png"
        is-icon-only="is-icon-only"
        background-color="#fff"
        heading="Auckland Events"
        inverse="inverse"
    ></smart-block>
  </div>
</template>
<script>
import SmartBlock from "../components/SmartBlock.vue";

export default {
  components: {
    SmartBlock
  }
}
</script>
